import type { ValidationDetail } from '@halo/web-types';

/**
 * Typed error thrown by the API client when a request fails.
 *
 * Carries machine-readable metadata so callers (React Query hooks,
 * mutation handlers, error boundaries) can branch on structured data
 * instead of parsing human-readable strings.
 */
export class ApiError extends Error {
  public override readonly name = 'ApiError';

  constructor(
    message: string,
    public readonly code: string,
    public readonly statusCode: number,
    public readonly requestId?: string,
    public readonly details?: readonly ValidationDetail[],
  ) {
    super(message);
  }
}

/** Type-guard: narrows an unknown error to ApiError. */
export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError;
}
